import posthog from "posthog-js";

// Single shared PostHog project for the whole Certified Code app fleet.
// Project: "Certified Code Apps" (PostHog EU, id 209378), routed via reverse proxy.
// Every event tagged with wix_app_id + app_name to segment per-app inside the one project.
export const POSTHOG_KEY = "phc_sUoxHEd3jKTDKgvy6nZscUdW6fmHRHfakcQeWdFYgcEP";
export const POSTHOG_HOST = "https://t.certifiedcode.us";
export const POSTHOG_UI_HOST = "https://eu.posthog.com";
export const WIX_APP_ID = "27fcc256-f3f8-47df-a66a-8f8176cc7f99";
export const APP_NAME = "TikTok Videos & Profile Embed";

let initialized = false;

export function initAnalytics(): void {
  if (initialized || typeof window === "undefined") return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    ui_host: POSTHOG_UI_HOST,
    defaults: "2026-05-30",
    person_profiles: "identified_only",
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    persistence: "localStorage+cookie",
    disable_session_recording: false,
    capture_exceptions: true,
    loaded: (ph) => {
      ph.register({ wix_app_id: WIX_APP_ID, app_name: APP_NAME });
    },
  });
  initialized = true;
}

export function identify(instanceId?: string | null): void {
  if (!instanceId) return;
  posthog.identify(instanceId, { wix_app_id: WIX_APP_ID, app_name: APP_NAME });
}

export function track(event: string, properties?: Record<string, unknown>): void {
  posthog.capture(event, { wix_app_id: WIX_APP_ID, app_name: APP_NAME, ...properties });
}

export default posthog;
